import { PenLine } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgPencilWriteAlternate = mkIcon(PenLine);